import { ReactElement } from 'react';
import cc from 'classcat';
import { COMPETITION_SKELETON_DEFAULT_LENGTH } from 'utils/constants/app/magic-numbers-app';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { createArray } from 'utils/helpers/create-fake-array';
import { isMobile } from 'utils/is-mobile';
import { ENotRealSports } from 'interfaces/not-real-sports';
import { ESportsbookPageTypes } from 'interfaces/sportsbook-configs';
import { USALayoutSkeleton } from './USAlayout';
import { ConditionalWrapper } from 'components/ConditionalWrapper';
import { EventCollapse } from 'components/EventCollapse';
import { MatchCardInlineSkeleton } from 'components/MatchCardInline/Skeleton';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import { useSportsbookConfigs } from 'hooks/sportsbook/useSportsbookConfigs';
import './index.less';

type Props = {
  sportAlias?: string;
  category?: ENotRealSports | string;
  count?: number;
  includeCollapse?: boolean;
  hideMargin?: boolean;
  className?: string;
};

export const CompetitionSkeleton = ({
  category,
  sportAlias,
  count,
  includeCollapse,
  hideMargin,
  className
}: Props): ReactElement => {
  const configs = useSportsbookConfigs();

  const isLive = configs.pageType === ESportsbookPageTypes.live;
  const length = count ? count : COMPETITION_SKELETON_DEFAULT_LENGTH;

  return (
    <ConditionalWrapper
      condition={!!includeCollapse}
      wrapper={children => (
        <EventCollapse
          style={{ margin: hideMargin ? 0 : '4px' }}
          wrapperClassName={className}
          defaultActive
          key="collapse"
          title={
            <Skeleton
              title={{ style: { width: 100, margin: 0, height: 15 } }}
              paragraph={false}
              active
            />
          }
        >
          {children || <> </>}
        </EventCollapse>
      )}
    >
      <div
        className={cc([
          'sportsbook__competition__skeleton',
          {
            'sportsbook__competition__skeleton--mobile':
              isMobile() && !hideMargin
          }
        ])}
      >
        {createArray(length).map(key =>
          (SpringConfigs.IS_AMERICAN_LAYOUT || +configs.spbLayoutType === 1) &&
          isMobile() ? (
            <USALayoutSkeleton
              key={key}
              sportAlias={sportAlias}
              showTitle={!isLive}
            />
          ) : (
            <MatchCardInlineSkeleton
              hideOdds={category === ENotRealSports.outright}
              key={key}
            />
          )
        )}
      </div>
    </ConditionalWrapper>
  );
};
